import './index.css';
import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  const f = window as any;
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  } else {
    document.head.appendChild(t);
  }
  f.fbq('init', '1962020738043581');
  f.fbq('track', 'PageView');
  f.fbq('track', 'ViewContent', {
    content_name: 'Wall Pilates 28 Días',
    content_category: 'Fitness Digital',
    value: 16990,
    currency: 'ARS'
  });
})();
render(<App data-id="element-285" />, document.getElementById('root'));